<template>
  <div class="view-product-checkout-layout">
    <h5 class="text-semibold">Modelo de checkout</h5>
    <h6 class="text-dark-40 fs-12 mb-7">
      Escolha entre um dos nossos templates. Você pode visualizar o template
      escolhido na versão desktop ou mobile.
    </h6>
    <div class="row">
      <div class="col-sm-6 mb-lg-0 mb-4">
        <div class="card-box" :class="{ selected: checkoutType === 'long' }">
          <div class="d-flex align-items-center justify-content-between">
            <snow-button-switch
              :options="[
                { icon: 'ph ph-desktop', value: 'desktop' },
                { icon: 'ph ph-device-mobile-camera', value: 'mobile' }
              ]"
              v-model="defaultScreen"
            />
            <input
              class="input-radio"
              type="radio"
              id="template-1"
              v-model="checkoutType"
              value="long"
            />
          </div>
          <div class="img-container">
            <img
              v-if="defaultScreen === 'desktop'"
              src="@/assets/images/checkout-layout/template-1-desktop.png"
            />
            <img
              v-if="defaultScreen === 'mobile'"
              src="@/assets/images/checkout-layout/template-1-mobile.png"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card-box" :class="{ selected: checkoutType === 'short' }">
          <div class="d-flex align-items-center justify-content-between">
            <snow-button-switch
              :options="[
                { icon: 'ph ph-desktop', value: 'desktop' },
                { icon: 'ph ph-device-mobile-camera', value: 'mobile' }
              ]"
              v-model="longScreen"
            />
            <input
              class="input-radio"
              type="radio"
              id="template-2"
              v-model="checkoutType"
              value="short"
            />
          </div>
          <div class="img-container">
            <img
              v-if="longScreen === 'desktop'"
              src="@/assets/images/checkout-layout/template-2-desktop.png"
            />
            <img
              v-if="longScreen === 'mobile'"
              src="@/assets/images/checkout-layout/template-2-mobile.png"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>

    <standard-checkout
      @cancel="standardCheckVisible = false"
      v-if="standardCheckVisible"
    />

    <checkout-builder
      v-if="customCheckVisible"
      :form="form"
      :loading="loading"
      @close="customCheckVisible = false"
      @save="onSubmit"
    />

    <modal-completed
      v-model="showSuccessModal"
      description="Suas alterações foram salvas com sucesso!"
      @action="showSuccessModal = false"
    />
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

import StandardCheckout from "@/components/product/checkout/StandardCheckout";
import CheckoutBuilder from "@/components/product/checkout/builder/CheckoutBuilder";
import SnowButtonSwitch from "@/components/snow-ui/SnowButtonSwitch.vue";

export default {
  components: {
    StandardCheckout,
    CheckoutBuilder,
    SnowButtonSwitch
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      showSuccessModal: false,
      standardCheckVisible: false,
      customCheckVisible: false,
      defaultScreen: "desktop",
      longScreen: "desktop",
      ...formFields(["id", "type", "components", "config", "product_id"], {
        id: null,
        type: "default",
        components: [
          {
            type: "details",
            position: "side",
            config: {},
            id: 1620000000000 - Date.now(),
            order: 0
          }
        ],
        config: {
          longPage: true
        },
        product_id: this.product.id,
        ...this.product.checkout_build
      }),
      checkoutType: this.product?.checkout_build?.config?.longPage
        ? "long"
        : "short"
    };
  },
  watch: {
    checkoutType(newVal) {
      this.form.config.longPage = newVal === "long";
      this.onSubmit();
    }
  },
  methods: {
    submitSuccess() {
      this.$router.push({ name: "product-details" });
    },
    onSubmit() {
      this.loading = true;
      const action = this.form.id
        ? "checkoutBuilder/put"
        : "checkoutBuilder/post";

      const data = { ...this.form };
      data.config.longPage = this.checkoutType === "long";
      data.type = "custom";

      this.$store
        .dispatch(action, data)
        .then(response => {
          this.form = response.data;
          if (this.customCheckVisible) {
            this.showSuccessModal = true;
          }
        })
        .catch(error => {
          if (error.response.data.details) {
            this.$message.error(error.response.data.details);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-checkout-layout {
  .card-box {
    padding: 20px;
    position: relative;

    .img-container {
      padding: 28px 0px;
      display: flex;
      align-items: start;
      justify-content: center;
      height: calc(100% - 56px);

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }
  .input-radio:checked:after {
    padding: 0px 0px 2px 0px;
    background-color: var(--blue);
    font-size: 14px;
    color: var(--light);
  }
}
</style>
